export const parsePcMediaSizeInput = (value: string): number | null => {
  const sanitized = value.replace(/[^0-9]/g, '')

  if (!sanitized) {
    return null
  }

  return Number(sanitized)
}
